import { render, staticRenderFns } from "./goods_list.vue?vue&type=template&id=01084ce9&scoped=true&"
import script from "./goods_list.vue?vue&type=script&lang=js&"
export * from "./goods_list.vue?vue&type=script&lang=js&"
import style0 from "./goods_list.vue?vue&type=style&index=0&id=01084ce9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01084ce9",
  null
  
)

export default component.exports